import axios from "axios";

class SiteService {
  static refresh = () => axios.get("/@refresh").then((response) => response.data);

  static getAllSites = () => axios.get("/getSites").then((response) => response.data);

  static get = (siteName) => axios.get("/@refresh", { params: { siteName } }).then((response) => response.data);
}

export default SiteService;
